export const ENDPOINTS = {
  STATIC_FILES: '/attachments/',
};

export const API_URL = process.env.NEXT_PUBLIC_API_URL;
export const API_STATIC_FILES = `${API_URL}${ENDPOINTS.STATIC_FILES}`;
